import { registerComponentInterceptor } from '../componentInterceptor';
import { default as React, useContext } from 'react';
import { SystemContext } from '../../contexts/SystemContext';
import { ConfigHelper, Feature } from '@devxdiscover/devhub-common';
import { ApplicationFeedbackButton } from '../insights/feedback/ApplicationFeedbackButton';

/**
 * Provides a custom layout for the EntityContextMenu on the Entity page.
 * @param _props - Props for the jsx element
 */
export const CustomEntityContextMenu = (_props: any) => {
  const { app } = useContext(SystemContext);
  // If this is not enabled, don't render anything
  if (!ConfigHelper.instance.isFeatureEnabled(Feature.FEEDBACK) || !app) {
    return <></>;
  }
  return <ApplicationFeedbackButton application={app} inHeader />;
};

/**
 * Register this component as an override for the default EntityContextMenu.
 */
registerComponentInterceptor({
  canIntercept(_type: React.ElementType, props: any, _key: React.Key) {
    return props.hasOwnProperty('UNSTABLE_extraContextMenuItems')
      ? true
      : false;
  },
  performIntercept(_type: React.ElementType, props: any, _key: React.Key) {
    return {
      element: <CustomEntityContextMenu props={props} />,
    };
  },
});
